<template>
    <div ref="pdfContent" class="print-area mt-3">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center">
            <div class="col-md-12">
                <h4>Sale Target Count</h4>
            </div>
        </div>

        <!-- 🔍 Filters Section -->
        <div class="card mb-4 shadow-sm border-0">
            <div class="card-body no-print">
                <div class="row g-3 align-items-end ">
                    <div class="col-md-3 position-relative">
                        <label>Employee</label>
                        <input type="text" class="form-control form-cascade-control input-small" v-model="searchAdvisor"
                            @input="filterAdvisorList" placeholder="Search Employee" autocomplete="off" />
                        <ul v-if="filteredAdvisor?.length > 0" class="list-group position-absolute suggestion-box">
                            <li class="list-group-item list-group-item-action" v-for="emp in filteredAdvisor"
                                :key="emp.id" @click="selectAdvisor(emp)">
                                {{ emp.name }} ({{ emp.generatedid }})
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-3">
                        <label>Month,Year</label>
                        <input type="month" class="form-control form-cascade-control input-small" v-model="filters.date"
                            placeholder="Enter Year" />
                    </div>

                    <!-- Buttons -->
                    <div class="col-md-2 ">
                        <button class="btn btn-info " @click="filteredSaleCount">
                            <i class="fa fa-search"></i>
                        </button>
                        <button class="btn btn-secondary ml-5" @click="refresh">
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>
                </div>
                <hr />
                <div class="col-md-12 row">
                    <div class="col-md-11 row">
                        <div class="col-md-4">
                            <div class="small_blog">
                                <label>Total Sale Count : </label>
                                <span class="total">
                                    {{ total_sale_count ?? 0 }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="small_blog">
                                <label>Total Lead Count : </label>
                                <span class="total">
                                    {{ total_lead_count ?? 0 }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="small_blog">
                                <label>Total Collection : </label>
                                <span class="total">
                                    {{ total_collection_count ?? 0 }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <button class="btn btn-primary" @click="printPDF" :disabled="targets?.length === 0">
                            Print
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <!-- 📋 Table Section -->
            <table class="table table-bordered table-striped text-center align-middle">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>VSDIGI-ID</th>
                        <th>Advisor name</th>
                        <th>Month</th>
                        <th>Year</th>
                        <th>Sale Counts</th>
                        <th>Leads Count</th>
                        <th>Collection Amt</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(target, index) in this.targets" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ target.advisor_vsdgid ?? 'N/A' }}</td>
                        <td>{{ target.advisor_name ?? 'N/A' }}</td>
                        <td>{{ monthName(month) ?? 'N/A' }}</td>
                        <td>{{ year }}</td>
                        <td>{{ target.total_sales ?? 0 }}</td>
                        <td>{{ target.total_leads ?? 0 }}</td>
                        <td>{{ target.total_collection ?? 0 }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash.debounce";
import html2pdf from 'html2pdf.js';

export default {
    data() {
        return {
            targets: [],
            filters: {
                advisor_id: "",
                date: new Date().toISOString().split("T")[0],
            },
            searchAdvisor: "",
            filteredAdvisor: [],
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            total_sale_count: 0,
            total_lead_count: 0,
            total_collection_count: 0,
        };
    },

    async mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.filters.advisor_id = "";
            this.searchAdvisor = "";
            this.filteredAdvisor = [];
            this.filters.date = new Date().toISOString().split("T")[0];
            this.filteredSaleCount();
        },
        async filteredSaleCount() {
            this.month = this.filters.date.split("-")[1]
            this.year = this.filters.date.split("-")[0]
            let param = {
                advisor_id: this.filters.advisor_id,
                month: this.month,
                year: this.year,

            }
            const { data } = await axios.post("/api/targetgoal/sales-count", param);
            this.targets = data;
            this.total_sale_count = this.targets.reduce((acc, target) => acc + parseFloat(target.total_sales), 0);
            this.total_lead_count = this.targets.reduce((acc, target) => acc + parseFloat(target.total_leads), 0);
            this.total_collection_count = this.targets.reduce((acc, target) => acc + parseFloat(target.total_collection), 0);
        },

        filterAdvisorList: debounce(async function () {
            if (this.searchAdvisor == "") {
                this.filters.advisor_id = 0
                this.filteredAdvisor = [];
                return;
            }
            try {
                const response = await axios.post('api/vsdigi/users/fetch', {
                    isadvisor: 1, columns: 'id,name,isadvisor,generatedid,companyid',
                    search: this.searchAdvisor, isdisabled: 0
                })
                this.filteredAdvisor = response.data;
            } catch (error) {
                console.error(error);
            }
        }, 1000),

        selectAdvisor(emp) {
            this.searchAdvisor = emp.name;
            this.filters.advisor_id = emp.id;
            this.filteredAdvisor = []; // ✅ hide list after selection
        },
        monthName(m) {
            return new Date(0, m - 1).toLocaleString("default", { month: "long" });
        },
        printPDF() {
            if (this.targets.length === 0) {
                alert("No data to print.");
                return;
            }

            const element = this.$refs.pdfContent;

            // Hide no-print elements manually
            const elementsToHide = document.querySelectorAll('.no-print');
            elementsToHide.forEach(el => el.style.display = 'none');

            const options = {
                margin: [0.5, 0.5, 0.5, 0.5],
                filename: `SaleTargetCount-${this.year}-${this.month}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };

            html2pdf()
                .from(element)
                .set(options)
                .save()
                .then(() => {
                    // Show them back again
                    elementsToHide.forEach(el => el.style.display = '');
                });
        }

    },
};
</script>

<style>
.card {
    border-radius: 10px;
}

.table {
    font-size: 14px;
}

.table th,
.table td {
    vertical-align: middle;
}

.form-label {
    font-weight: 600;
}

.fs-17 {
    font-size: 17px;
}

.list-group-item {
    padding: 0.5rem;
    font-size: 14px;
}

@media print {
    .no-print {
        display: none !important;
    }
}
</style>
